import React from "react";

export const schema = {
        title: "",
        description: "",
        type: "object",
        //required: ["title"],
        properties: {
            vertebral_flexion: {type: "integer", title: "", default: ""},
            vertebral_extension: {type: "integer", title: "", default: ""},
            transverse_rotation_left_cervical: {type: "integer", title: "", default: ""},
            transverse_rotation_right_cervical: {type: "integer", title: "", default: ""},
            transverse_rotation_left_thoracic: {type: "integer", title: "", default: ""},
            transverse_rotation_right_thoracic: {type: "integer", title: "", default: ""},
            lateral_flexion_left: {type: "integer", title: "", default: ""},
            lateral_flexion_right: {type: "integer", title: "", default: ""}
        }
}

export const uiSchema = {

    vertebral_flexion: {
        "ui:widget": "updown",
        "ui:title": "Vertebral Flexion",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Rate 0 - 100%",
        "ui:placeholder": "0"
    },
    vertebral_extension: {
        "ui:widget": "updown",
        "ui:title": "Vertebral Extension",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Rate 0 - 100%",
        "ui:placeholder": "0"
    },
    transverse_rotation_left_cervical: {
        "ui:widget": "updown",
        "ui:title": "Transverse Rotation Left Cervical",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Rate 0 - 100%",
        "ui:placeholder": "0"
    },
    transverse_rotation_right_cervical: {
        "ui:widget": "updown",
        "ui:title": "Transverse Rotation Right Cervical",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Rate 0 - 100%",
        "ui:placeholder": "0"
    },
    transverse_rotation_left_thoracic: {
        "ui:widget": "updown",
        "ui:title": "Transverse Rotation Left Thoracic", /* changes title name */
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Rate 0 - 100%",
        "ui:placeholder": "0"
    },
    transverse_rotation_right_thoracic: {
        "ui:widget": "updown",
        "ui:title": "Transverse Rotation Right Thoracic",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Rate 0 - 100%",
        "ui:placeholder": "0"
    },
    lateral_flexion_left: {
        "ui:widget": "updown",
        "ui:title": "Lateral Flexion Left",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Rate 0 - 100%",
        "ui:placeholder": "0"
    },
    lateral_flexion_right: {
        "ui:widget": "updown",
        "ui:title": "Lateral Flexion Right",
        "classNames": "heart-total-chol-ratio",
        "ui:description": "Rate 0 - 100%",
        "ui:placeholder": "0"
    }
}



// WEBPACK FOOTER //
// ./src/components/assessment/schema/SpinalROM.js